import type React from 'react'
import type { JSX } from 'react'
import type { GeoblockErrorScreenPadding } from './GeoblockErrorScreen.h'

import {
  GeoblockErrorScreenAlignItems,
  GeoblockErrorScreenDirection,
  GeoblockErrorScreenJustifyContent,
  GeoblockErrorScreenPaddings,
} from './GeoblockErrorScreen.h'
import { GeoblockErrorScreenStyled } from './GeoblockErrorScreen.styled'

export interface IGeoblockErrorScreenProps {
  children: React.ReactNode
  width?: string
  height?: string
  direction?: GeoblockErrorScreenDirection
  alignItems?: GeoblockErrorScreenAlignItems
  justifyContent?: GeoblockErrorScreenJustifyContent
  padding?: GeoblockErrorScreenPadding
}

export const GeoblockErrorScreen = ({
  children,
  width = '100%',
  height = '100%',
  direction = GeoblockErrorScreenDirection.Column,
  alignItems = GeoblockErrorScreenAlignItems.FlexStart,
  justifyContent = GeoblockErrorScreenJustifyContent.FlexEnd,
  padding = GeoblockErrorScreenPaddings.SIZE_0,
}: IGeoblockErrorScreenProps): JSX.Element => (
  <GeoblockErrorScreenStyled
    width={width}
    height={height}
    direction={direction}
    alignItems={alignItems}
    justifyContent={justifyContent}
    padding={padding}
  >
    {children}
  </GeoblockErrorScreenStyled>
)
